import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { verifyRegistration } from '../apiCallsHelper/authapicalls';
import todoLogo from "../images/TodoMate-logo.png"
import LoadingOverlay from './../utils/LoadingOverlay';



const AccountVerification = () => {

  const { verificationTkn } = useParams();

  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");



  const handleVerifyEmail = () => {
    verifyRegistration(verificationTkn).then(data => {
      if (data.error) {
        setMessage(data.error);
        setLoading(false);
      }
      else {
        setLoading(false);
        setMessage(data.message);
      }
    })

  }




  useEffect(() => {
    handleVerifyEmail();
  }, []);




  return (
    <>

      <Link className='flex mt-12 justify-center text-blue-300' to="/">
        <img src={todoLogo} className=' w-[80px] h-[80px]' alt="todo logo" />
      </Link>
      <div className='container mt-[-40px] mx-auto w-[400px] h-[330px] border-2 border-gray-300 rounded-md'>
        <div className='w-[300px] mx-auto mt-16'>
          <div className='text-3xl mt-8 text-center text-[#183e70] font-bold '>
            Account Verification
          </div>
          <div className='mt-6 text-center text-[#142e52]'>
            {loading ? (
              <div>Please wait while we verify your account
                <span>
                    <LoadingOverlay />
                </span>
              </div>

            ) : (
              <>
                <div>Thank you for staying connected.</div>
                <div>{message}</div>
                <div className='mt-8'>
                  <Link className=' flex justify-center bg-[#a6bffc] py-2 px-4 w-full rounded-md font-medium hover:bg-[#6f8dd9] hover:text-white' to="/signin">
                    Login?
                  </Link>
                </div>
              </>
            )
            }
          </div>
        </div>
      </div>
    </>
  )
}



export default AccountVerification;